import React from 'react';
import { clsx } from '../utils/utils';
import * as styles from './Footer.module.scss';

import infosysLogoImage from '../images/infosys-logo.svg';
import { Link } from 'gatsby';

export interface FooterProps {
  className?: string;
  noMobileShare?: boolean;
  onShareClick: () => void;
}

const Footer = ({ className, noMobileShare, onShareClick }: FooterProps): React.ReactElement => {
  return (
    <div className={clsx(styles.container, noMobileShare && styles.noMobileShare, className)}>
      <div className={styles.rippedPaper}></div>
      <div className={styles.contentContainer}>
        {/* <Link
          to="/privacy-policy"
          className={clsx(styles.privacyPolicyLink, styles.privacyPolicyLinkOutside)}
        >
          Privacy Policy
        </Link> */}
        <a
          className={styles.poweredByLink}
          target="_blank"
          rel="noreferrer"
          href="https://www.infosys.com/"
        >
          <div className={styles.poweredByContainer}>
            <span className={styles.poweredBy}>Powered by</span>
            <img className={styles.infosysLogo} src={infosysLogoImage}></img>
          </div>
        </a>
        <div className={styles.shareAndPrivacyContainer}>
          <span className={styles.shareLink} onClick={onShareClick}>
            Share
          </span>
          {/* <Link
          to="/privacy-policy"
          className={clsx(styles.privacyPolicyLink, styles.privacyPolicyLinkInside)}
        >
          Privacy Policy
        </Link> */}
        </div>
      </div>
    </div>
  );
};

export default Footer;
